export const audits = {
	navTitle: "Auditoría",
	filters: {
		employeePlaceholder: "Filtrar por empleado",
		typePlaceholder: "Filtrar por tipo",
		functionPlaceholder: "Filtrar por función",
	},
	table: {
		columns: {
			date: "Fecha",
			employee: "Empleado",
			place: "Establecimiento",
			organization: "Organización",
			type: "Tipo",
			function: "Función",
			observation: "Observación",
			params: "Parámetros",
			createdAt: "Creado en",
		},
		viewParams: "Ver",
		paramsModalTitle: "Parámetros",
		exportFilename: "Auditorías",
		exportTitle: "Reporte de Auditorías",
	},
};
